import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// Utils
import { notifyError, notifySuccess } from "Services/Utils/toastNotification";

// API End Points
import { API_END_POINTS } from "Middleware/apiEndpoints";

// API calls
//Login request
export const loginRequest = createAsyncThunk("loginRequest", async (data) => {
  // api hit
  const response = await APIKit().post(
    `${API_END_POINTS.loginRequest}`,
    data?.data
  );
  if (
    response?.data?.message === "User logged in successfully!" &&
    response?.status === 200
  ) {
    data?.callBack(response?.data);
    localStorage.setItem("userDetails", JSON.stringify(response?.data?.data));
  } else if (
    response?.data?.message === "Otp sent successfully!" &&
    response?.status === 200
  ) {
    data?.callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.loginRequest} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

//Logout request
export const logoutRequest = createAsyncThunk("logoutRequest", async (data) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.logoutRequest}`);
  if (response?.status === 200) {
    data?.callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.logoutRequest} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

//Trigger email for forgot password request
export const triggerEmailForForgotPasswordRequest = createAsyncThunk(
  "triggerEmailForForgotPasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.triggerEmailForForgotPasswordRequest}${data?.email}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${
          API_END_POINTS.triggerEmailForForgotPasswordRequest
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);

//Check link for create password request
export const checkLinkForCreatePasswordRequest = createAsyncThunk(
  "checkLinkForCreatePasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.checkLinkForCreatePasswordRequest}${data?.slug}`
    );
    if (response?.status === 200) {
      const userDetails = JSON.parse(localStorage?.getItem("userDetails"));
      const updatedUserDetails = {
        ...userDetails,
        token: response?.data?.token,
        email: response?.data?.email,
      };
      localStorage?.setItem("userDetails", JSON.stringify(updatedUserDetails));
    } else {
      notifyError(response?.data?.message);
      data?.navigate("/");      
      console.log(
        `Error ===> ${
          API_END_POINTS.checkLinkForCreatePasswordRequest
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);

//Forgot password request
export const forgotPasswordRequest = createAsyncThunk(
  "forgotPasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.forgotPasswordRequest}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${
          API_END_POINTS.forgotPasswordRequest
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);

export const changePasswordRequest = createAsyncThunk(
  "changePasswordRequest",
  async ({data,callBack}) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.changePasswordRequest}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${
          API_END_POINTS.forgotPasswordRequest
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const policyRequest = createAsyncThunk(
  "policyRequest",
  async ({data,callBack}) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getPolicy}?content_type=${data.id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${
          API_END_POINTS.getPolicy
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const deleteAccountRequest = createAsyncThunk(
  "deleteAccountRequest",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.deleteAccount}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.deleteAccount} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const deleteConfirmationRequest = createAsyncThunk(
  "deleteConfirmationRequest",
  async ({ slug, iv, data, callBack }) => {
    try {
      const response = await APIKit().delete(
        `${API_END_POINTS.deleteConfimation}?encryptedSlug=${encodeURIComponent(slug)}&iv=${encodeURIComponent(iv)}`,
        data
      );

      if (response?.status === 200) {
        callBack(response?.data);
        notifySuccess("Account Deleted Successfully");
      } else {
        notifyError(response?.data?.message);
        console.error(
          `Error ===> ${API_END_POINTS.deleteConfimation} ====> ${JSON.stringify(
            response
          )}`
        );
      }
      return response?.data;
    } catch (error) {
      console.error("API Error:", error);
      notifyError("Failed to delete account. Please try again.");
      throw error;
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    //Login Request
    builder
      .addCase(loginRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(loginRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(loginRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Logout Request
    builder
      .addCase(logoutRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(logoutRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(logoutRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Trigger email for forgot password Request
    builder
      .addCase(triggerEmailForForgotPasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        triggerEmailForForgotPasswordRequest.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        triggerEmailForForgotPasswordRequest.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Check link for create password request
    builder
      .addCase(checkLinkForCreatePasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(checkLinkForCreatePasswordRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(checkLinkForCreatePasswordRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Forgot password request
    builder
      .addCase(forgotPasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(forgotPasswordRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(forgotPasswordRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Login Page Policy Content
    builder
      .addCase(policyRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(policyRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(policyRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    
    builder
      .addCase(deleteAccountRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteAccountRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteAccountRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default authSlice.reducer;
